import { createSelector } from 'reselect';

import { filters } from '@Containers/ResultsFilters/ResultsFiltersComponents/ListOfFilters/ListOfFiltersSelectors';

export const filterMap = {
  [1]: handleGroupFilter,
  [2]: handleGroupFilter,
  [4]: handleCheckboxFilter,
  [5]: handleStructureFilter,
  [6]: handleFullTextFilter,
};

export function handleGroupFilter(filter) {
  const groups = filter.get('groups');
  const userInputValue = filter.get('userInputValue');

  if (!groups.count()) {
    return false;
  }

  if (userInputValue) {
    return true;
  }

  return groups.some((item) => item.get('selected'));
}

export function handleCheckboxFilter(filter) {
  return filter.get('selected');
}

export function handleStructureFilter(filter) {
  return filter.get('selected');
}

export function handleFullTextFilter(filter) {
  return filter.get('userInputValue')?.trim() !== '';
}

export const disableButtons = createSelector([filters], (filters) => {
  if (!filters) {
    return true;
  }
  const result = filters.some((filter) => {
    const type = filter.get('type');
    const handler = filterMap[type];
    if (!handler) {
      return false;
    }
    return handler(filter);
  });

  return !result;
});
